import { usePathname } from 'next/navigation';
import { useNavigation } from '../contexts/NavigationContext';
import { useRuntime } from '../runtime/RuntimeContext';
import { stripLangPrefix } from '../i18n/locale';
import { pathnameToTab } from '../lib/screen-url-map';
import type { TabId } from '../types/tabs';

export const useHighlightedTab = (): TabId | null => {
  const runtime = useRuntime();
  const navigation = useNavigation();
  const pathname = usePathname();
  return runtime === 'web' ? pathnameToTab(stripLangPrefix(pathname)) : navigation.state.activeTab;
};
